import React from 'react';
const Footer = () =>{
  return (
    <footer>
      <div className="container">
        <div className="footer-links">
          <a href="mailto:info@dhapufarms.com">info@dhapufarms.com</a> | <a href="tel:+919713801215">+91 97138 01215</a>
        </div>
        <p>© 2024 Dhapu Farms. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;